import { useEffect, useState, useRef } from 'react';
import { nameMessageSystem } from '../utils/nameMessages';

const TickerTape = () => {
  const [currentMessage, setCurrentMessage] = useState('');
  const timeoutRef = useRef(null);

  const updateMessage = () => {
    const message = nameMessageSystem.getRandomMessage();
    setCurrentMessage(message);
    
    // Set random delay for next message (1-7 seconds)
    const randomDelay = 1000 + Math.random() * 6000; // 1000-7000ms
    timeoutRef.current = setTimeout(updateMessage, randomDelay);
  };

  useEffect(() => {
    // Initial message
    updateMessage();

    // Cleanup on unmount
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <div className="ticker-tape" style={{
      background: 'linear-gradient(90deg, #87CEEB 0%, #B0E2FF 100%)',
      color: '#1E3A8A',
      padding: '6px 0',
      margin: '8px 0',
      textAlign: 'center',
      fontWeight: '500',
      fontSize: '13px',
      borderRadius: '4px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }}>
      🎯 {currentMessage}
    </div>
  );
};

export default TickerTape;